import { BehaviorSubject } from 'rxjs';
import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
//import * as appConfig from '../../../../../src/app/app-config.json';
import { of, Observable } from 'rxjs';
import { map, catchError } from 'rxjs/operators';
import { CryptoService } from './crypto.service';

const APP_CONFIG_URL = 'assets/config/app-config.json';

@Injectable({
  providedIn: 'root'
})
export class ConfigService {

  constructor(protected httpClient: HttpClient) {
    //this._rootUrl = '/';
    //this._apiUrl = 'http://192.168.0.1/webmatapitest/';
  }

  private _rootUrl: string;
  private _apiUrl: string;
  private _companyDataServiceUrl: string;
  private _pricelistUrl: string;

  private _minutesUntilAutoLogout: number = 240;
  private _autoLogoutCheckInterval: number = 60000;
  private _autoLogoutStoreKey: string = 'last-action';

  private selectedOrgJedSubject = new BehaviorSubject(CryptoService.Decrypt(sessionStorage.getItem('sel-org-jed')));
  SelectedOrgJed: Observable<any> = this.selectedOrgJedSubject.asObservable();

  private selectedUserSubject = new BehaviorSubject(CryptoService.Decrypt(sessionStorage.getItem('sel-user')));
  SelectedUser: Observable<any> = this.selectedUserSubject.asObservable();

  
  ngOnDestroy() {
    this.selectedOrgJedSubject.complete();
    this.selectedUserSubject.complete();
  }

  GetRootUrl(){
    return this._rootUrl;
  }

  GetApiUrl(){
    return this._apiUrl;
  }

  GetApiUrlAsync(): Observable<any>{
    if(this._apiUrl == null || this._apiUrl == ''){
      return this.httpClient.get(APP_CONFIG_URL)
        .pipe(map(config => {
          this._apiUrl = config['apiUrl'];
          return config['apiUrl'];
        }), catchError(err => {
          console.log(err);
          return of([]);
        }));
    }
    else {
      return of(this._apiUrl);
    }
  }

  SetRootUrl(rootUrl: string){
    this._rootUrl = rootUrl;
  }

  SetApiUrl(apiUrl: string){
    this._apiUrl = apiUrl;
  }

  GetMinutesUntilAutoLogout(){
    return this._minutesUntilAutoLogout;
  }

  GetAutoLogoutCheckInterval(){
    return this._autoLogoutCheckInterval;
  }

  GetAutoLogoutStoreKey(){
    return this._autoLogoutStoreKey;
  }

  SetSelectedOrgJed(orgJed){
    if (orgJed) {
      let cryptedOrgJed = CryptoService.Encrypt(orgJed);
      sessionStorage.setItem('sel-org-jed', cryptedOrgJed);
    }
    else
      sessionStorage.removeItem('sel-org-jed');
      this.selectedOrgJedSubject.next(orgJed);
  }

  SetSelectedUser(user) {
    let cryptedUser = CryptoService.Encrypt(user);
    sessionStorage.setItem('sel-user', cryptedUser);
    this.selectedUserSubject.next(user);
  }

  GetCompanyDataServiceUrlAsync(): Observable<any>{
    if(this._companyDataServiceUrl == null || this._companyDataServiceUrl == ''){
      return this.httpClient.get(APP_CONFIG_URL)
        .pipe(map(config => {
          this._companyDataServiceUrl = config['companyDataServiceUrl'];
          return config['companyDataServiceUrl'];
        }))
    }
    else{
      return of(this._companyDataServiceUrl);
    }
  }

  GetPricelistUrl(){
    return this._pricelistUrl;
  }

  GetPricelistUrlAsync(): Observable<any>{
    if(this._pricelistUrl == null || this._pricelistUrl == ''){
      return this.httpClient.get(APP_CONFIG_URL)
        .pipe(map(config => {
          this._pricelistUrl = config['pricelistUrl'];
          return config['pricelistUrl'];
        }), catchError(err => {
          console.log(err);
          return of([]);
        }));
    }
    else {
      return of(this._pricelistUrl);
    }
  }

  SetPricelistUrl(pricelistUrl: string){
    this._pricelistUrl = pricelistUrl;
  }

}
